// src/utils/StudentInfo_engine.js

export const calculateStudentInfo = (answers) => {
  const risks = [];
  
  // --- AİLE DURUMU ANALİZİ ---
  // Soru 6: Anne-Baba Hayatta mı?
  if (answers[6] === 'Anne Vefat') risks.push({ id: 6, text: 'Anne Vefat Etmiş', category: 'Aile', isCritical: true });
  if (answers[6] === 'Baba Vefat') risks.push({ id: 6, text: 'Baba Vefat Etmiş', category: 'Aile', isCritical: true });
  if (answers[6] === 'Ikisi Vefat') risks.push({ id: 6, text: 'Anne ve Baba Vefat', category: 'Aile', isCritical: true });

  // Soru 7: Birliktelik
  if (answers[7] === 'Ayri') risks.push({ id: 7, text: 'Anne-Baba Ayrı (Boşanmış)', category: 'Aile', isCritical: false });

  // Soru 5: Kiminle Yaşıyor?
  if (answers[5] === 'Akraba' || answers[5] === 'Diğer') risks.push({ id: 5, text: 'Ebeveyn Dışı Bakım', category: 'Aile', isCritical: false });

  // Soru 8: Kardeş Sayısı
  if (answers[8] === '5+') risks.push({ id: 8, text: 'Çok Kardeşli (5+)', category: 'Aile', isCritical: false });

  // --- EKONOMİK DURUM ANALİZİ ---
  // Soru 9: Gelir
  if (answers[9] === 'Yok' || answers[9] === 'Dusuk') {
    risks.push({ id: 9, text: 'Düşük Gelir Düzeyi', category: 'Ekonomik', isCritical: true });
  }

  // Soru 11: Çalışma Durumu
  if (answers[11] === 'Evet') risks.push({ id: 11, text: 'Öğrenci Çalışıyor', category: 'Ekonomik', isCritical: true });

// --- SAĞLIK & ÖZEL DURUM ANALİZİ ---
  // Geriye dönük uyumluluk: Yeni formda 160, 170, 180 "Evet" ise metne bak. Eski formda direkt metne bak.
  const isYes = (ansRadio, ansText) => {
    // Yeni form: "Evet" seçilmiş olması tek başına yeterlidir.
    if (ansRadio === 'Evet') return true;

    // Eski form kayıtlarıyla geriye dönük uyumluluk:
    // Radio cevabı yoksa açıklama alanındaki gerçek bir metni dikkate al.
    if (
        !ansRadio &&
        typeof ansText === 'string' &&
        ansText.trim().length > 2 &&
        !['hayır', 'hayir', 'yok', 'yoktur'].includes(ansText.trim().toLowerCase())
    ) {
        return true;
    }

    return false;
};

  const hasChronic = isYes(answers[160], answers[16]);
  const hasMedication = isYes(answers[170], answers[17]);
  const hasOperation = isYes(answers[180], answers[18]);
  // DİKKAT: 'text' sadece ana başlık oldu, hastalık adını 'detail' içine attık!
    if (hasChronic) risks.push({
    text: 'Kronik Hastalık',
    category: 'Sağlık',
    isCritical: true,
    code: 'KH',
    detail: answers[16] ?? null
  });

  if (hasMedication) risks.push({
    text: 'Sürekli İlaç',
    category: 'Sağlık',
    isCritical: false,
    code: 'Sİ',
    detail: answers[17] ?? null
  });

  if (hasOperation) risks.push({
    text: 'Geçmiş Kaza/Ameliyat',
    category: 'Sağlık',
    isCritical: false,
    code: 'GA',
    detail: answers[18] ?? null
  });
  

 // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  const criticalCount = risks.filter(r => r.isCritical).length;
  const normalCount = risks.filter(r => !r.isCritical).length;

  // Dezavantajlılık Skoru: (Kritik x 35) + (Normal x 15), maksimum 100.
  const riskScore = Math.min(100, (criticalCount * 35) + (normalCount * 15));

  let masterRisk = "low";
  if (criticalCount > 0) masterRisk = "high"; // Vefat, fakirlik, hastalık varsa direkt kırmızı
  else if (normalCount > 0) masterRisk = "medium"; // Sadece boşanma veya çok kardeş varsa sarı

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: riskScore,
    masterRisk: masterRisk,
    isCritical: false, // Öğrenci Bilgi Formu öncelik/dezavantaj taramasıdır; tek başına acil kriz alarmı üretmez
    domain: "demographic", // Demografik / Sosyo-Ekonomik alan

    // 2. Mevcut Detaylı Veriler (Dokunmadık)
    summary: "Bilgi Formu Kaydedildi",
    analysis: "Öğrenci demografik bilgileri işlendi.",
    risks: risks, 
    chartData: [], 
       raw: {
      kiminleYasiyor: answers[5] ?? null,
      anneBabaHayatta: answers[6] ?? null,
      birliktelik: answers[7] ?? null,
      kardesSayisi: answers[8] ?? null,
      gelirDurumu: answers[9] ?? null,
      evDurumu: answers[10] ?? null,
      calisiyorMu: answers[11] ?? null,
      kronikHastalik: hasChronic,
      ilacKullanimi: hasMedication,
      ulasim: answers[19] ?? null
    }
  };
};